export const getCanAccessCookieValue = (cookieName: string) => {
  let isEnabled = false;

  if (typeof window === 'undefined') {
    return isEnabled;
  }

  const cookies = document.cookie.split('; ');

  cookies.forEach((cookie) => {
    if (cookie.includes(cookieName)) {
      isEnabled = cookie.split('=')?.[1] === 'true';
    }
  });

  return isEnabled;
};
